import { Button, Form } from "react-bootstrap";
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";
import { UsersGroup } from "../interfaces/UsersGroup";
import { useTranslation } from "react-i18next";
import { Overlay } from "../elements/Overlay";

export interface UsersGroupDeleteProps {
    usersGroup: UsersGroup;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function UsersGroupDelete(props: UsersGroupDeleteProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/users-groups/' + props.usersGroup._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.usersGroup._id);
            })
            .catch(error => {
                navigate('/');
            });
    }

    return(
        <Overlay
            title={ t("Delete group") }
            onClose={ handleClose }
            className="admin-delete-faq-container"
        >
            <Form onSubmit={ handleSubmit }>
                <Form.Text id="deleteConfirmationMessage">
                    { parse(t("You are about to delete organization content <strong>{{name}}</strong>. 'This action cannot be undone. Are you sure you want to proceed?", {name: props.usersGroup.name}))
                    }
                </Form.Text>
                <div className="actions">
                    <Button variant="primary" type="submit">{ t("Yes") }</Button>
                    <Button variant="secondary" onClick={ handleClose }>{ t("No") }</Button>
                </div>
            </Form>
        </Overlay>
    );
}